import React from 'react'

const RegionCardFooter = ({children, classNames, className, pagination = false}) => {
  return (
    <div className={`card-footer ${pagination ? "d-flex align-items-center justify-content-center" : ""} ${classNames || className || ""}`}>
      {children}
    </div>
  );
}

export default RegionCardFooter;